<template>
  <div>
    <span class="DepartmentUser"
      v-for="e in userList"
      :key="e.id"
      :title="JSON.stringify(e)">{{e.name || '#' + e.id}}</span>
  </div>
</template>

<script>
export default {
  name: "DepartmentUser",

  props : ['id'],

  data() {
    return {
      userList : []
    }
  },

  mounted() {
      var _this = this;
      sdk.TicketUserApi().listByDepartmentId({
          departmentId : this.id
      }).then(res => {
          _this.userList = res;
      });
  }
}
</script>

<style>
  .DepartmentUser {
    margin: 2px 2px;
    padding: 0 5px;
    background: #efefef;
    border-radius:5px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/setting/DepartmentUser.vue